import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { TypedUseSelectorHook, useSelector, useDispatch } from 'react-redux';

import { CustomerRootState } from '../ducks/customer/types';

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<CustomerRootState> = useSelector;
export type AppDispatch = ThunkDispatch<CustomerRootState, any, AnyAction>;
export type AsyncAction = ThunkAction<any, CustomerRootState, any, AnyAction>;
